import React, { Children, useContext } from 'react';
import _merge from 'lodash/merge';
import { ToggleGroupButtonContext } from 'components/ToggleButtonGroup';
import { getContext } from 'common';
import Styled from './styles';

export interface ToggleGroupIconProps {
  /** Consider using <Icon> component. */
  children: React.ReactNode;
  /** Modifies the visual style to correspond to the status color. */
  status?: 'critical' | 'major' | 'minor' | 'warning' | 'non-status';
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: {};
}

const ToggleGroupIcon = React.forwardRef<HTMLElement, ToggleGroupIconProps>((props, ref) =>
  getContext(({ theme }) => {
    const { status, theme: themeProp, children } = props;
    const toggleGroupButtonContext = useContext(ToggleGroupButtonContext);
    const { isSelected, disabled }: any = toggleGroupButtonContext;
    const toggleButtonGroupTheme = _merge({}, theme.TOGGLE_BUTTON_GROUP, themeProp);
    if (status === 'non-status') {
      const content = React.cloneElement(Children.toArray(children)[0] as React.ReactElement<any>, { 'data-parent': 'button', size: 24 });
      return <Styled.ToggleButtonIconWrapper ref={ref}>{content}</Styled.ToggleButtonIconWrapper>;
    }
    let color;
    switch (status) {
      case 'critical':
        color = disabled ? toggleButtonGroupTheme.disabled.critical.icon : isSelected ? toggleButtonGroupTheme.ON.critical.icon : toggleButtonGroupTheme.OFF.critical.icon;
        break;
      case 'major':
        color = disabled ? toggleButtonGroupTheme.disabled.major.icon : isSelected ? toggleButtonGroupTheme.ON.major.icon : toggleButtonGroupTheme.OFF.major.icon;
        break;
      case 'minor':
        color = disabled ? toggleButtonGroupTheme.disabled.minor.icon : isSelected ? toggleButtonGroupTheme.ON.minor.icon : toggleButtonGroupTheme.OFF.minor.icon;
        break;
      case 'warning':
        color = disabled ? toggleButtonGroupTheme.disabled.warning.icon : isSelected ? toggleButtonGroupTheme.ON.warning.icon : toggleButtonGroupTheme.OFF.warning.icon;
        break;
      default:
        color = undefined;
    }
    const content = React.cloneElement(Children.toArray(children)[0] as React.ReactElement<any>, {
      'data-parent': 'togglegroupbutton',
      color,
      size: 24,
      ref
    });
    return <Styled.ToggleButtonIconWrapper ref={ref}>{content}</Styled.ToggleButtonIconWrapper>;
  }));

ToggleGroupIcon.displayName = 'ToggleGroupIcon';
ToggleGroupIcon.defaultProps = {
  status: 'non-status',
  theme: {}
};
export default ToggleGroupIcon;
